import { useUtilisateurService } from '@europrocurement/l2d-domain';
import { UserJsonld } from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import { useCallback, useRef } from 'react';

export const useUser = () => {
    const cacheRef = useRef<Partial<Record<string, UserJsonld | null>>>({});
    const pendingPromisesRef = useRef<Partial<Record<string, Promise<UserJsonld | null>>>>({});
    const { userKeycloakApi } = useUtilisateurService();

    const fetchUser = useCallback(
        async (userIdentifier: string): Promise<UserJsonld | null> => {
            if (!userIdentifier) return null;
            if (cacheRef.current[userIdentifier] !== undefined) {
                return cacheRef.current[userIdentifier];
            }
            if (pendingPromisesRef.current[userIdentifier]) {
                return pendingPromisesRef.current[userIdentifier]!;
            }
            const userPromise = userKeycloakApi
                .apiKeycloakUtilisateursIdidentityGet({
                    id: userIdentifier,
                })
                .then(async (response) => {
                    const user = await response.data;
                    cacheRef.current[userIdentifier] = user;
                    return user;
                })
                .catch((error) => {
                    console.error('Erreur:', error);
                    cacheRef.current[userIdentifier] = null;
                    return null;
                })
                .finally(() => {
                    delete pendingPromisesRef.current[userIdentifier];
                });

            pendingPromisesRef.current[userIdentifier] = userPromise;

            return userPromise;
        },
        [userKeycloakApi],
    );

    return { fetchUser, cache: cacheRef.current };
};
